import EventsKeywordFilter from './EventsKeywordFilter';
import EventListingService from './api/EventListingService';
import EventsCalendarView from './calendarView/EventsCalendarView';
import CalendarViewMode from './calendarView/EventsCalendarViewMode';
import EventsListView from './listView/EventsListView';
import PrimaryViewToggle from './PrimaryViewToggle';
import ViewMode from './EventListingViewMode';
import DateFormat from './date/EventListingDateFormat';
import DateFormatter from './date/EventListingDateFormatter';
import UrlSearchParamsConfig from './UrlSearchParamsConfig';
import { parseYYYYMMDD } from './date/DateHelpers';

class EventListing {
  constructor(constructorOptions = {}, dateFormats = {}) {
    const defaults = {
      calendarViewMode: CalendarViewMode.MONTH,
      defaultView: ViewMode.CALENDAR,
      additionalApiData: {},
    };

    const convertedDates = {
      defaultDisplayDate: parseYYYYMMDD(constructorOptions.defaultDisplayDate),
      earliestEventDate: parseYYYYMMDD(constructorOptions.earliestEventDate),
      latestEventDate: parseYYYYMMDD(constructorOptions.latestEventDate),
      listingStartDate: parseYYYYMMDD(constructorOptions.listingStartDate),
      listingEndDate: parseYYYYMMDD(constructorOptions.listingEndDate),
    };

    // Merge config sources in the following order:
    const config = Object.assign(
      defaults,
      constructorOptions,
      convertedDates,
      UrlSearchParamsConfig,
    );

    config.additionalApiData.keywordIds = config.keywordIds;

    DateFormatter.setDateFormats(dateFormats);
    EventListingService.setAdditionalApiData(config.additionalApiData);

    const { isMultiMode, defaultView } = config;

    const keywordFilter = new EventsKeywordFilter(config);
    const viewToggle = new PrimaryViewToggle(defaultView, isMultiMode);

    if (isMultiMode || defaultView === ViewMode.LIST) {
      this.listView = new EventsListView(config, keywordFilter, viewToggle);
    }
    if (isMultiMode || defaultView === ViewMode.CALENDAR) {
      this.calendarView = new EventsCalendarView(config, keywordFilter, viewToggle);
    }

    viewToggle.notify();
  }
}

EventListing.ViewMode = ViewMode;
EventListing.DateFormat = DateFormat;

window.tnew.EventListing = EventListing;

export default EventListing;



// WEBPACK FOOTER //
// ./V7/events/listing/EventListing.js